<template>
  <div class="section-box">
    <el-tabs v-model="tabType" type="card" class="customer-tabs-mg" :before-leave="tabSelect">
      <el-tab-pane v-for="(item, index) in titleCourse" :label="item.value" :name="item.key + ''" :key="index">
      </el-tab-pane>
    </el-tabs>
    <div class="customer-list">
      <div class="next-button">
        <el-button size="small" type="primary" @click="getautoExamEngineerInfoList()">查询</el-button>
        <el-button size="small" type="primary" icon="el-icon-download" @click="downloadFile()">下载数据</el-button>
        <el-button size="small" type="success" @click="resetSearch()">重置</el-button>
      </div>
    </div>

    <el-table :stripe="true" :data="tableData" style="width: 100%; margin-top: 20px" height="590" border
      v-loading="listLoading">
      <!-- eslint-disable  -->
      <el-table-column label="姓名">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model="form.userName" placeholder="输入关键字搜索"
              @change="getautoExamEngineerInfoList()" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.userName || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="手机号">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model="form.handset" placeholder="输入关键字搜索"
              @change="getautoExamEngineerInfoList()" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.handset || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="证书名称">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model="form.certificateName" placeholder="输入关键字搜索"
              @change="getautoExamEngineerInfoList()" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.certificateName || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column label="申请时间">
        <el-table-column show-overflow-tooltip width="250">
          <template slot="header" slot-scope="scope">
            <el-date-picker size="mini" v-model="form.applyTime" type="daterange" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始日期" end-placeholder="结束日期"
              style="width: 100%" @change="getautoExamEngineerInfoList()"></el-date-picker>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.paySuccessTime || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="金额">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model="form.payAmount" placeholder="输入关键字搜索"
              @change="getautoExamEngineerInfoList()" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.payAmount || "0" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="getDetail(scope.row)" :type="scope.row.auditStatusBtn" size="mini">{{
            scope.row.auditStatusText }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right" v-show="tableData.length">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="form.pageNum" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 弹框 -->
    <el-dialog title="个人信息" :visible.sync="dialogVisible" class="dialog-info" width="760px">
      <div>
        <h3>{{ detail.userName }}</h3>
        <el-image :src="detail.photoUrl" fit="contain"></el-image>
        <el-image :src="detail.educationFileUrl" fit="contain"></el-image>
        <el-image :src="detail.idCartUrl" fit="contain"></el-image>
        <h3>收货地址</h3>
        <p class="address">{{ detail.receiverAddress }}</p>
      </div>
      <span slot="footer" class="dialog-footer" v-if="detail.auditStatus == 1">
        <el-button type="primary" @click="audit(2)">审核通过</el-button>
        <el-button @click="audit(3)" type="danger">审核不通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  autoExamEngineerInfoList,
  autoExamEngineerDetail,
  autoExamEngineerDetailAudit
} from "@/service/examination.js";
import { getStorageAdminUser } from '@/utils/store'
export default {
  components: {},
  data() {
    return {
      userInfo: getStorageAdminUser(),
      tabType: '1',
      titleCourse: [],
      listLoading: false,
      form: {
        pageNum: 1,
        pageSize: 10,
        certificateName: "",
        userName: "",
        handset: "",
        applyTime: [],
        payAmount: '',   //支付金额结束
      },
      searchData: {},
      total: 0,

      tableData: [],
      detail: {},
      dialogVisible: false
    };
  },
  created() {
    this.tableData = [];
    this.getTitle();
    this.getautoExamEngineerInfoList();
  },
  methods: {
    resetSearch() {
      this.form = {
        pageNum: 1,
        pageSize: 10,
        certificateName: "",
        userName: "",
        handset: "",
        applyTime: [],
        payAmount: '',   //支付金额结束
      }
      this.getautoExamEngineerInfoList();
    },
    downloadFile() {
      var data = {};
      if (this.form.certificateName) data.certificateName = this.form.certificateName;
      if (this.form.userName) data.userName = this.form.userName;
      if (this.form.handset) data.handset = this.form.handset;
      if (this.form.payAmount) data.payAmount = this.form.payAmount;
      if (
        this.form.applyTime instanceof Array &&
        this.form.applyTime.length > 0
      ) {
        data.paySuccessTimeBegin = this.form.applyTime[0] + " 00:00:00";
        data.paySuccessTimeEnd = this.form.applyTime[1] + " 23:59:59";
      } else {
        if (data.paySuccessTimeBegin) delete data.paySuccessTimeBegin;
        if (data.paySuccessTimeEnd) delete data.paySuccessTimeEnd;
      }
      let str = '';
      //拼接参数字符串
      for (const k in data) {
        if (Object.hasOwnProperty.call(data, k)) {
          str += `${k}=${data[k]}&`
        }
      }
      let url = process.env.NODE_ENV == "development" ? "/api2/service" : process.env.VUE_APP_API2;
      window.open(
        url + `/autoExamEngineer/info/list/export?${str}`
      );
    },
    parseJsonURL(json) {
      if (!json) return "";
      if (typeof json == "string") return json;
      return this.cleanArray(
        Object.keys(json).map(function (key) {
          if (json[key] === undefined) return "";
          return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
        })
      ).join("&");
    },
    cleanArray(actual) {
      var newArray = [];
      for (var i = 0; i < actual.length; i++) {
        if (actual[i]) {
          newArray.push(actual[i]);
        }
      }
      return newArray;
    },
    async getautoExamEngineerInfoList() {
      this.listLoading = true;
      var data = {
        rational: true,
        pageNum: 1,
        pageSize: 10,
      };
      if (
        this.form.applyTime instanceof Array &&
        this.form.applyTime.length > 0
      ) {
        data.paySuccessTimeBegin = this.form.applyTime[0] + " 00:00:00";
        data.paySuccessTimeEnd = this.form.applyTime[1] + " 23:59:59";
      } else {
        if (data.paySuccessTimeBegin) delete data.paySuccessTimeBegin;
        if (data.paySuccessTimeEnd) delete data.paySuccessTimeEnd;
      }
      if (this.form.userName) data.userName = this.form.userName;
      if (this.form.handset) data.handset = this.form.handset;
      if (this.form.certificateName) data.certificateName = this.form.certificateName;
      if (this.form.payAmount) data.payAmount = this.form.payAmount;
      data.pageNum = this.form.pageNum;
      data.pageSize = this.form.pageSize;

      let res = await autoExamEngineerInfoList(data);
      this.listLoading = false;
      if (res.Result != 1) {
        return this.$message.error("获取失败请联系开发人员");
      }
      this.tableData = res.Data.datas;
      this.total = res.Data.total;
      if (this.tableData.length) {
        this.tableData.map(item => {
          item.auditStatusText = {
            0: '未提交资料',
            1: '待审核',
            2: '审核成功',
            3: '审核失败'
          }[item.auditStatus]
          item.auditStatusBtn = {
            0: 'info',
            1: 'warning',
            2: 'primary',
            3: 'danger'
          }[item.auditStatus]
        })
      }
    },
    getTitle() {
      this.titleCourse = [{
        key: 1,
        value: "数字化工程师",
      }, {
        key: 2,
        value: "报名页",
      }];
    },
    handleSizeChange(val) {
      if (this.listLoading) return;
      this.form.pageNum = 1;
      this.form.pageSize = val;
      this.getautoExamEngineerInfoList();
    },
    handleCurrentChange(val) {

      if (this.listLoading) return;
      this.form.pageNum = val;

      this.getautoExamEngineerInfoList();
    },
    async getDetail(item) {
      if (!item.auditStatus) return;
      this.dialogVisible = true;
      let res = await autoExamEngineerDetail({
        nuserId: item.id,
        platform: 'pcweb'
      })
      console.log("res", res);
      if (res.Result == 1) {
        this.detail = res.Data;
      } else {
        return this.$message.error(res.Message);
      }
    },
    async audit(status) {
      let res = await autoExamEngineerDetailAudit({
        "auditAdminUserId": this.userInfo.role_id,
        "auditStatus": status,
        "nuserId": this.detail.id,
        "nuserType": 1,
        "platform": "pcweb"
      })
      if (res.Result === 1) {
        this.$message.success("设置成功")
        this.dialogVisible = false;
      } else {
        return this.$message.error(res.Message);
      }
    },

    
    //切换tab之前
    tabSelect(activeName, oldActiveName) {
      console.log('activeName:' + activeName + ";oldActiveName:" + oldActiveName);
      if (activeName == "2") {
        this.$router.push('certSign');
        return false;
      }
    }

  },
};
</script>
<style lang="scss">
.customer-tabs-mg {
  .el-tabs__header {
    margin: 0 0 15px !important;
  }
}

.customer-list {
  position: relative;

  .next-button {
    position: absolute;
    right: 0;
    top: -56px;
  }
}

.customer-row-bg {
  padding: 20px 14px;
  background-color: #f9fafc;
  display: flex;
  align-items: center;

  .el-form-item {
    margin-bottom: 0 !important;
  }

  .selected {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}

.linkInfo {
  cursor: pointer;

  &:hover {
    color: #409eff;
  }
}

.dialog-info {
  .el-image {
    width: 200px;
    height: 200px;
    margin-right: 40px;
    margin-bottom: 1em;
    margin-top: 1em;
  }

  .address {
    border: 1px solid #E4E7ED;
    color: #666;
    padding: 5px 15px;
    line-height: 1.5;
    box-sizing: border-box;
    min-height: 100px;
    border-radius: 5px;
  }
}
</style>